import {pdfjs} from 'react-pdf/dist/cjs/index.js'
/**
 * The recommended “import worker” approach requires Webpack 5+, while this project remains on Webpack 4.
 * To avoid external CDN dependencies, pdf.worker.min.mjs is copied into public/
 * and GlobalWorkerOptions.workerSrc is set to '/pdf.worker.min.mjs'.
 */
pdfjs.GlobalWorkerOptions.workerSrc = process.env.REACT_APP_BASENAME
  ? `${process.env.REACT_APP_BASENAME}/pdf.worker.min.mjs`
  : '/pdf.worker.min.mjs'
